import { Box, Tab, Tabs, IconButton, makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../shared/Theme';

const useStyles = makeStyles((theme) => ({
	sideHeader: {
		width: '100%',
		height: '100vh',
		maxWidth: '290px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		overflow: 'hidden',
		padding: '40px 0',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
	logo: {
		marginTop: '30px',
		padding: '0 40px',
		'& img': {
			width: '100%',
		},
	},
	menuBox: {
		width: '100%',
		minHeight: '82%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		textAlign: 'center',
		gap: '18px',
		color: '#fff',
		fontSize: '18px',
	},
	menu: {
		'& .Mui-selected': {
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
		'& .MuiTabs-indicator': {
			backgroundColor: `${COLORS.PUMPKIN}`,
		},
	},
	iconAlignBox: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
	},
	IconSize: {
		width: '25px',
		height: '25px',
	},
	linkTab: {
		...theme.typography.body1,
		fontFamily: 'NanumR',
		padding: 0,
		color: `${COLORS.LIGHT_GREY}`,
		'&:hover': {
			color: `${COLORS.WHITE}`,
		},
	},
}));

function a11yProps(index: any) {
	return {
		id: `nav-tab-${index}`,
		'aria-controls': `nav-tabpanel-${index}`,
	};
}

interface LinkTabProps {
	label?: string;
	href?: string;
	history?: any;
	classNameProps?: any;
	member?: any;
	[key: string]: any;
}

function LinkTab(props: LinkTabProps) {
	const { classNameProps, history, href, member, ...other } = props;

	return (
		<Tab
			component="a"
			href={href}
			onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
				event.preventDefault();
				history.push({
					pathname: href,
					...(member && {
						state: {
							code: member.classCode,
						},
					}),
				});
			}}
			className={classNameProps}
			{...other}
		/>
	);
}

const pathToTabIndex = (paths: string[], path: string): number | false => {
	const normalized = path.split('?')[0].replace(/\/$/, '') || '/';
	if (normalized === '/') return 0;
	const idx = paths.findIndex((element) => element === normalized || element === path);
	return idx >= 0 ? idx : false;
};

// 경영현황 / 연구개발 / 재료구매 / 제품생산 / 제품판매
const address = ['/CompanyInfo', '/LicenseList', '/ProductionList', '/MaterialPurchase', '/ProductList' /*'/ProductSale'*/];
const SideHeader = () => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	const [value, setValue] = useState<number | false>(pathToTabIndex(address, window.location.pathname));
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(address, location.pathname));
		});
	}, [history]);

	return (
		<header className={classes.sideHeader}>
			<Box className={classes.logo}>
				<img src="/images/logo_white.png" />
			</Box>
			<Box className={classes.menuBox}>
				<Tabs className={classes.menu} indicatorColor="secondary" orientation="vertical" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab label={t('HeaderBar.tabCompanyInfo')} classNameProps={classes.linkTab} href={address[0]} history={history} {...a11yProps(0)} data-testid="company-info-tab" />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabLicenseList')} href={address[1]} history={history} {...a11yProps(1)} data-testid="manu-license-list-tab" />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabProductionList')} href={address[2]} history={history} {...a11yProps(2)} data-testid="manu-production-tab" />
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.tabMaterialPurchase')}
						href={address[3]}
						history={history}
						{...a11yProps(3)}
						data-testid="manu-material-purchase-tab"
					/>
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.tabProductList')} href={address[4]} history={history} {...a11yProps(4)} data-testid="manu-product-tab" />
				</Tabs>
			</Box>
			<Box className={classes.iconAlignBox}>
				<Box>
					<IconButton onClick={goQnA}>
						<img className={classes.IconSize} src="/images/question.png" />
					</IconButton>
					<IconButton onClick={goSetting}>
						<img className={classes.IconSize} src="/images/Settings.webp" />
					</IconButton>
					<IconButton onClick={refresh}>
						<img className={classes.IconSize} src="/images/refresh_white2.png" />
					</IconButton>
				</Box>
			</Box>
		</header>
	);
};

const d_address = ['/CompanyInfo', '/MaterialSale', '/ProductPurchase', '/MaterialList', '/ProductPurchaseList'];
const d_tab_paths = [d_address[0], d_address[1], d_address[2], d_address[4]];
export const DistributionSideHeader: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	const [value, setValue] = useState<number | false>(pathToTabIndex(d_tab_paths, window.location.pathname));
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(d_tab_paths, location.pathname));
		});
	}, [history]);

	return (
		<header className={classes.sideHeader}>
			<Box className={classes.logo}>
				<img src="/images/logo_white.png" />
			</Box>
			<Box className={classes.menuBox}>
				<Tabs className={classes.menu} orientation="vertical" indicatorColor="secondary" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab label={t('HeaderBar.distTabCompanyInfo')} classNameProps={classes.linkTab} href={d_address[0]} history={history} {...a11yProps(0)} data-testid="company-info-tab" />
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.distTabMaterialSale')} href={d_address[1]} history={history} {...a11yProps(1)} data-testid="dist-material-sale-tab" />
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.distTabProductPurchase')}
						href={d_address[2]}
						history={history}
						{...a11yProps(2)}
						data-testid="dist-product-purchase-tab"
					/>
					{/* <LinkTab classNameProps={classes.linkTab} label="보유재료" href={d_address[3]} history={history} {...a11yProps(3)} /> */}
					<LinkTab classNameProps={classes.linkTab} label={t('HeaderBar.distTabOwnedProduct')} href={d_address[4]} history={history} {...a11yProps(3)} data-testid="dist-owned-product-tab" />
				</Tabs>
			</Box>
			<Box className={classes.iconAlignBox}>
				<Box>
					<IconButton onClick={goQnA}>
						<img className={classes.IconSize} src="/images/question.png" />
					</IconButton>
					<IconButton onClick={goSetting}>
						<img className={classes.IconSize} src="/images/Settings.webp" />
					</IconButton>
					<IconButton onClick={refresh}>
						<img className={classes.IconSize} src="/images/refresh_white2.png" />
					</IconButton>
				</Box>
			</Box>
		</header>
	);
};

const oper_address = ['/operation/company/list', '/operation/decomposition/appList', '/operation/classCode', '/operation/ClassRun'];
export const OperSideHeader: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	const [value, setValue] = useState<number | false>(pathToTabIndex(oper_address, window.location.pathname));
	const { oper } = props;
	const history = useHistory();

	const goSetting = () => {
		history.push(`/setting`);
	};

	const goQnA = () => {
		history.push(`/qna`);
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	const refresh = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (history === undefined) return;
		return history.listen((location: any) => {
			setValue(pathToTabIndex(oper_address, location.pathname));
		});
	}, [history]);

	return (
		<header className={classes.sideHeader}>
			<Box className={classes.logo}>
				<img src="/images/logo_white.png" />
			</Box>
			<Box className={classes.menuBox}>
				<Tabs className={classes.menu} indicatorColor="secondary" orientation="vertical" value={value} onChange={handleChange} aria-label="nav tabs">
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabCompanyList')}
						href={oper_address[0]}
						history={history}
						{...a11yProps(0)}
						data-testid="oper-company-list-tab"
					/>
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabDecompositionAppList')}
						href={oper_address[1]}
						history={history}
						{...a11yProps(1)}
						data-testid="oper-decomposition-manage-tab"
					/>
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabClassQr')}
						href={oper_address[2]}
						history={history}
						{...a11yProps(2)}
						member={oper}
						data-testid="oper-class-qr-tab"
					/>
					<LinkTab
						classNameProps={classes.linkTab}
						label={t('HeaderBar.operTabRanking')}
						href={oper_address[3]}
						history={history}
						{...a11yProps(3)}
						member={oper}
						data-testid="oper-ranking-tab"
					/>
				</Tabs>
			</Box>
			<Box className={classes.iconAlignBox}>
				<Box>
					<IconButton onClick={goQnA}>
						<img className={classes.IconSize} src="/images/question.png" />
					</IconButton>
					<IconButton onClick={goSetting}>
						<img className={classes.IconSize} src="/images/Settings.webp" />
					</IconButton>
					<IconButton onClick={refresh}>
						<img className={classes.IconSize} src="/images/refresh_white2.png" />
					</IconButton>
				</Box>
			</Box>
		</header>
	);
};

export default SideHeader;
